import { render, staticRenderFns } from "./MeuPlano.vue?vue&type=template&id=7fbc5f81&scoped=true"
import script from "./MeuPlano.vue?vue&type=script&lang=js"
export * from "./MeuPlano.vue?vue&type=script&lang=js"
import style0 from "./MeuPlano.vue?vue&type=style&index=0&id=7fbc5f81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc5f81",
  null
  
)

export default component.exports